import styled from '@emotion/styled';
import * as tokens from '@tokens';
import type { PropsOf } from '@emotion/react';
import type { RowProps, RowTypes } from './TablePartsTypes';

export const Body = styled('tbody')<{
  children: RowTypes;
}>``;

export const Foot = styled('tfoot')<{
  children: RowTypes;
}>``;

/**
 * Body Row
 */
export const Row = styled('tr')<RowProps>`
  display: table-row;
  background-color: ${tokens.color.ui_background};

  &:hover {
    background-color: ${tokens.color.neutral_100};
  }
`;

export const Cell = styled('td')<
  Omit<
    PropsOf<'td'>,
    'children' | 'abbr' | 'axis' | 'bgColor' | 'headers' | 'as'
  >
>`
  ${tokens.text('body2')}
  color: ${tokens.color.text_default};
  background-color: inherit;
  border-bottom: 1px solid ${tokens.color.ui_border_light};
  height: ${tokens.spacer.x7};
  vertical-align: top;
  text-align: left;
  padding: ${tokens.spacer.x2} ${tokens.spacer.x2};
`;

/**
 * Styled Head Row
 */
export const StyledHeadRow = styled('tr')<{ isVisible: boolean }>`
  display: table-row;

  ${({ isVisible }) =>
    !isVisible &&
    `
    visibility: hidden;
  `};
`;

StyledHeadRow.defaultProps = {
  isVisible: true,
};
